import React from 'react';
import { createBrowserRouter, RouterProvider, Outlet } from 'react-router-dom';
import MyAppBar from "../Components/MyAppBar";
import Home from '../Home';
import About from "./About";
import InfoGraphics from "./InfoGraphics";
import Publications from "./Publications";
import Tutorial from "./Tutorial";
import RadioIllustrations from "./RadioIllustrations";
import ShortVideos from "./ShortVideos";
import Login from "./Admin/Login/Index";
import ReduxLerning from "./ReduxLerning";
import AdminLayout from "./Admin/AdminLayout";
import AdminHome from "./Admin/AdminHome";
import AdminUsers from "./Admin/AdminUsers";
import AdminSettings from "./Admin/AdminSettings";
import AdminMessages from "./Admin/AdminMessages";
import AdminArticlesList from "./Admin/Articles/AdminArticlesList";
import AdminArticleEditor from "./Admin/Articles/AdminArticleEditor";
import AdminAlbumsList from "./Admin/Albums/AdminAlbumsList";
import Articles from "./Articles";
import ArticleView from "./Articles/ArticleView";
import Blogs from "./Blogs";
import Album from "./Album";
import Search from "./Search";
import PrivacyPolicy from "./PrivacyPolicy";
import Disclaimer from "./Disclaimer";
import Contact from "./Contact";
import Terms from "./Terms";
import Footer from "../Components/Footer";
import AnalyticsTracker from "../Components/AnalyticsTracker";

// Public layout with MyAppBar - will receive router via closure
let routerInstance: ReturnType<typeof createBrowserRouter> | null = null;

const createPublicLayout = () => {
    return () => (
        <>
            {routerInstance && <MyAppBar router={routerInstance} />}
            <Outlet />
            <Footer />
        </>
    );
};

const RootLayout = () => {
    return (
        <>
            <AnalyticsTracker />
            <Outlet />
        </>
    );
};

// Create router configuration
const routerConfig = [
    {
        Component: RootLayout,
        children: [
            {
                Component: createPublicLayout(),
                children: [
                    { path: '/', Component: Home },
                    { path: '/about', Component: About },
                    { path: '/infographics', Component: InfoGraphics },
                    { path: '/publications', Component: Publications },
                    { path: '/tutorial', Component: Tutorial },
                    { path: '/radioillustrations', Component: RadioIllustrations },
                    { path: '/shortVideos', Component: ShortVideos },
                    { path: '/reduxstore', Component: ReduxLerning },
                    { path: '/login', Component: Login },
                    { path: '/articles', Component: Articles },
                    { path: '/articles/:slug', Component: ArticleView },
                    { path: '/blogs', Component: Blogs },
                    { path: '/album/:id', Component: Album },
                    { path: '/Album/:id', Component: Album },
                    { path: '/search', Component: Search },
                    { path: '/contact', Component: Contact },
                    { path: '/privacy-policy', Component: PrivacyPolicy },
                    { path: '/terms', Component: Terms },
                    { path: '/disclaimer', Component: Disclaimer },
                ],
            },
            {
                path: '/admin',
                Component: AdminLayout,
                children: [
                    { index: true, Component: AdminHome },
                    { path: 'users', Component: AdminUsers },
                    { path: 'settings', Component: AdminSettings },
                    { path: "articles", Component: AdminArticlesList },
                    { path: "articles/new", Component: AdminArticleEditor },
                    { path: "articles/:id/edit", Component: AdminArticleEditor },
                    { path: "albums", Component: AdminAlbumsList },
                    { path: "messages", Component: AdminMessages },
                ],
            },
        ],
    },
];

// Create router
routerInstance = createBrowserRouter(routerConfig);

export default function AppRouter() {
    return <RouterProvider router={routerInstance!} />;
}
